import r from "./noop.js";
import o from "./get.js";
function t(t) {
  return null == t ? r : function (r) {
    return o(t, r);
  };
}
export { t as default };